import { Component, OnInit } from '@angular/core';
import { globals } from 'src/app/shared/globals';
import { Router, NavigationStart } from '@angular/router';
import { LoginComponent } from '../account/login.component';
import { CoursewareService } from 'src/services/CoursewareService';

@Component({
  selector: 'nav-menu',
  templateUrl: './navmenu.component.html',
  styleUrls: ['./navmenu.component.css'],
})
export class NavMenuComponent implements OnInit {
  ngOnInit(): void {
    this._router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        console.log("NavigationStart");
        if (typeof window !== 'undefined') {
          let expandedNavBar = document.getElementById("navbarTogglerDemo02");
          if (expandedNavBar)
            expandedNavBar.classList.remove("show");
          else
            console.log("could not find navbarTogglerDemo02");
        }
      }
    });
  }

  public constructor(private coursewareService: CoursewareService, private _router: Router) {
  }

  public getUserName() {
    if (globals.userName)
      return globals.userName;
    return null;
  }

  public isFoundationsOfLawActive() {
    if (this._router.url.indexOf('coursewareview') >= 0 || this._router.url.indexOf('coursewarecontentview') >= 0) {
      return 700;
    }
    return 400;
  }

  public isShortVideosActive() {
    if (this._router.url.indexOf('shortvideosview') >= 0 || this._router.url.indexOf('shortvideoscontentview') >= 0 || this._router.url.indexOf('blogview') >= 0 || this._router.url.indexOf('blogentryview') >= 0) {
      return 700;
    }
    return 400;
  }

  public isResearchIndexActive() {
    if (this._router.url.indexOf('researchindexview') >= 0) {
      return 700;
    }
    return 400;
  }


  public isVideoCoursesActive() {
    if (this._router.url.indexOf('videocoursesview') >= 0 || this._router.url.indexOf('videocoursescontentview') >= 0 || this._router.url.indexOf('videocoursesmoduleview') >= 0 || this._router.url.indexOf('videocoursesbannerview') >= 0 || this._router.url.indexOf('explainerview') >= 0) {
      return 700;
    }
    return 400;
  }

  public getFoundationsOfLawWidth() {
    if (this._router.url.indexOf('coursewareview') >= 0 || this._router.url.indexOf('coursewarecontentview') >= 0) {
      return 257;
    }
    return 256;
  }

  public getShortVideosWidth() {
    if (this._router.url.indexOf('shortvideosview') >= 0 || this._router.url.indexOf('shortvideoscontentview') >= 0 || this._router.url.indexOf('blogview') >= 0 || this._router.url.indexOf('blogentryview') >= 0) {
      return 178;
    }
    return 177;
  }

  public getVideoCoursesWidth() {
    if (this._router.url.indexOf('videocoursesview') >= 0 || this._router.url.indexOf('videocoursescontentview') >= 0 || this._router.url.indexOf('videocoursesmoduleview') >= 0 || this._router.url.indexOf('videocoursesbannerview') >= 0 || this._router.url.indexOf('explainerview') >= 0) {
      return 700;
    }
    return 400;
  }

  public doLogout() {
    LoginComponent.user = null;
    this.coursewareService.Logout(globals.token).subscribe(data => {
      globals.userName = null;
      if (typeof window !== 'undefined') {
        localStorage.removeItem('token');
        localStorage.removeItem('username');
      }
    });
  }
}
